/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf
 */
export interface BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf {
    /**
     * 
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf
     */
    'cardType': BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum;
    /**
     * Expiration date of the previous virtual card that was replaced by automatic reissuance.
     * @type {string}
     * @memberof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOf
     */
    'expiredDate': string;
}

export const BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = {
    virtual: 'virtual'
} as const;

export type BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum = typeof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum[keyof typeof BulkDisableMonthlyUsageLimit200ResponseInnerReissueOneOfCardTypeEnum];


